module.exports = __webpack_public_path__ + "img/github.7c677400.svg";